module.exports = __webpack_public_path__ + "static/media/2.2.83760d40.zip";